import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  ModalLayout,
  InputFormTable,
  HtmlContent,
  Editor,
} from 'components';
import {
  Button,
  DatePicker,
  Input,
  Radio,
  Switch,
  Flex,
  Spin,
  Tag,
  Select,
} from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { downloadXlsx } from 'utils/XlsxDownloader';
const INITIAL_VALUE = {
  start: '',
  end: '',
  search: '',
  type: 'ALL',
  show: '',
};
const SORT_ITEMS = [
  {
    label: '최신등록순',
    value: 'created_at-DESC',
  },
  {
    label: '오래된 등록순',
    value: 'created_at-ASC',
  },
];
const NoticeListPresenter = (props) => {
  const {
    data,
    isOpened,
    modalData,
    // selectedItems,
    // setSelectedItems,
    isCheckedAll,
    checkedList,
    onChecked,
    onCheckedAll,
    modalType,
    onChange,
    onOpen,
    onSubmit,
    onDelete,
    setIsLoading,
    isLoading,
  } = props;

  const [sortValue, setSortValue] = React.useState('created_at-DESC');
  const [filterItem, setFilterItem] = React.useState(INITIAL_VALUE);
  const [filterList, setFilterList] = React.useState([]);

  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const handleChange = (t, v) => {
    setFilterItem((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  const formItem = [
    {
      label: '노출대상',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.type}
              onChange={(e) => handleChange('type', e.target.value)}
            >
              <Radio value={'ALL'}>전체</Radio>
              <Radio value={'USER'}>회원</Radio>
              <Radio value={'ADMIN'}>관리자</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '등록일자',
      form: [
        {
          input: (
            <Flex gap="large" size="large">
              <Radio.Group
                size="large"
                onChange={(e) => {
                  setFilterItem((prev) => ({
                    ...prev,
                    start: dayjs()
                      .subtract(e.target.value, 'day')
                      .startOf('day'),
                    end: dayjs().endOf('day'),
                  }));
                }}
              >
                <Radio.Button value={1}>1일</Radio.Button>
                <Radio.Button value={7}>7일</Radio.Button>
                <Radio.Button value={30}>30일</Radio.Button>
                <Radio.Button value={90}>90일</Radio.Button>
              </Radio.Group>

              <Flex align="center" gap={4}>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={filterItem.start ? dayjs(filterItem.start) : ''}
                  onChange={(e) =>
                    setFilterItem((prev) => ({ ...prev, start: e }))
                  }
                  maxDate={filterItem.end}
                />
                <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder=""
                  style={{ ...styles.form.date, width: 150 }}
                  value={filterItem.end ? dayjs(filterItem.end) : ''}
                  onChange={(e) =>
                    setFilterItem((prev) => ({ ...prev, end: e }))
                  }
                  minDate={filterItem.start}
                />
              </Flex>
            </Flex>
          ),
        },
      ],
    },
    {
      label: '제목',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="공지사항 제목을 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
                value={filterItem.search}
                onChange={(e) =>
                  setFilterItem((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </>
          ),
        },
      ],
    },
    {
      label: '노출여부',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.show}
              onChange={(e) => handleChange('show', e.target.value)}
            >
              <Radio value={''}>전체</Radio>
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '고정여부',
      form: [
        {
          input: (
            <Radio.Group
              value={filterItem.fixed}
              onChange={(e) => handleChange('fixed', e.target.value)}
            >
              <Radio value={''}>전체</Radio>
              <Radio value={'Y'}>고정</Radio>
              <Radio value={'N'}>비고정</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
  ];

  const form = [
    {
      label: '제목',
      required: true,
      form: [
        {
          input: (
            <Input
              size="large"
              placeholder="새 게시글의 제목을 입력해주세요"
              style={{ width: 400 }}
              value={modalData?.notice?.notice_name ?? ''}
              onChange={(e) =>
                onChange('notice_name', e.target.value, 'notice')
              }
            />
          ),
          count: true,
          maxLength: 50,
        },
      ],
    },
    {
      label: '노출여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.notice?.is_show ?? 'N'}
              onChange={(e) => onChange('is_show', e.target.value, 'notice')}
            >
              <Radio value={'Y'}>노출</Radio>
              <Radio value={'N'}>숨김</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '공지사항 타겟',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.notice?.show_target ?? 'ALL'}
              onChange={(e) =>
                onChange('show_target', e.target.value, 'notice')
              }
            >
              <Radio value={'ALL'}>전체</Radio>
              <Radio value={'USER'}>회원</Radio>
              <Radio value={'ADMIN'}>관리자</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '상단 고정여부',
      required: true,
      form: [
        {
          input: (
            <Radio.Group
              value={modalData?.notice?.is_fixed ?? 'N'}
              onChange={(e) => onChange('is_fixed', e.target.value, 'notice')}
            >
              <Radio value={'Y'}>고정</Radio>
              <Radio value={'N'}>비고정</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '내용',
      form: [
        {
          input: (
            <Editor
              height={430}
              initialContent={modalData?.notice?.notice_content ?? ''}
              editorOnChange={(content) =>
                onChange('notice_content', content, 'notice')
              }
            />
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  const col = [
    {
      title: 'No',
      key: 'notice_id',
    },
    {
      title: '구분',
      key: 'show_target_html',
    },
    {
      title: '제목',
      key: 'notice_name',
      width: 500,
    },
    {
      title: '등록일',
      key: 'created_at',
      render: (item) => dayjs.unix(item).format('YYYY.MM.DD'),
    },
    {
      title: '수정일',
      key: 'updated_at',
      render: (item) => dayjs.unix(item).format('YYYY.MM.DD'),
    },
    {
      title: '노출여부',
      key: 'is_show',
      render: (item) => (
        <Tag color={item === 'Y' ? 'processing' : 'default'}>
          {item === 'Y' ? '노출' : '숨김'}
        </Tag>
      ),
    },
    {
      title: '상단 고정여부',
      key: 'is_fixed',
      render: (item) => (
        <Tag color={item === 'Y' ? 'processing' : 'default'}>
          {item === 'Y' ? '고정' : '비고정'}
        </Tag>
      ),
    },
  ];
  /* ===== FUNCTION ===== */

  /**
   * 테이블 데이터 생성
   * @returns {Array}
   */
  const tableData = React.useMemo(() => {
    const newData = data?.map((item) => ({
      ...item,
      key: item?.notice_id,
      notice_id: item?.notice_id,
      show_target_html:
        item?.show_target === 'ADMIN' ? (
          <span
            style={{
              border: '1px solid #37383C',
              color: '#37383C',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            관리자
          </span>
        ) : item?.show_target === 'USER' ? (
          <span
            style={{
              border: '1px solid #58cf04',
              color: '#58cf04',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            회원
          </span>
        ) : (
          <span
            style={{
              border: '1px solid #FF881A',
              color: '#FF881A',
              borderRadius: 2,
              padding: '1px 11px',
            }}
          >
            전체
          </span>
        ),
      is_show_html: <Switch checked={item?.is_show === 'Y'} />,
    }));
    const split = sortValue.split('-');
    const sortData = newData?.sort((a, b) => {
      switch (split[1]) {
        case 'DESC':
          return b[split[0]] - a[split[0]];
        case 'ASC':
          return a[split[0]] - b[split[0]];
        default:
          return 0;
      }
    });

    return sortData;
  }, [data, sortValue]);

  /**
   * 문의 조건 검색
   * --
   * @param {string} t
   */
  const handleSearch = (t) => {
    setIsLoading(true);
    const searchType = t.toLocaleUpperCase();

    let arr = [...tableData];
    switch (searchType) {
      case 'RESET':
        setFilterItem(INITIAL_VALUE);
        break;
      case 'SEARCH':
        const { start, end, search, type, show, fixed } = filterItem;

        if (search) {
          arr = arr.filter((notice) => notice.notice_name.includes(search));
        }

        if (type) {
          arr = arr.filter((notice) => notice.show_target === type);
        }

        if (show) {
          arr = arr.filter((notice) => notice.is_show === show);
        }

        if (start || end) {
          const filterType = start && end ? 'BETWEEN' : start ? 'START' : 'END';

          switch (filterType) {
            case 'START':
              arr = arr.filter(
                (notice) =>
                  notice.created_at >= dayjs(start).startOf('day').unix(),
              );
              break;
            case 'END':
              arr = arr.filter(
                (notice) => notice.created_at <= dayjs(end).endOf('day').unix(),
              );
              break;
            case 'BETWEEN':
              arr = arr.filter(
                (notice) =>
                  notice.created_at >= dayjs(start).startOf('day').unix() &&
                  notice.created_at <= dayjs(end).endOf('day').unix(),
              );
              break;
            default:
              break;
          }
        }

        if (fixed) {
          arr = arr.filter((notice) => notice.is_fixed === fixed);
        }

        break;
      default:
        break;
    }

    setTimeout(() => {
      setIsLoading(false);
      setFilterList(arr);
    }, 1000);
  };

  React.useEffect(() => {
    setFilterList(tableData);
  }, [tableData]);

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={isLoading}>
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              <Title style={{ ...styles.title }}>공지사항 관리</Title>
              {/* 검색필터 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'none'}
                style={{ marginBottom: 40 }}
              >
                <ExpandableContainer borderRadius={4} padding={20}>
                  {formItem.map((_item, _index) => (
                    <div
                      key={`form_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      <div
                        style={{ minWidth: 120, fontSize: 13, fontWeight: 400 }}
                      >
                        <label>{_item.label}</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {_item.form.map((_subitem, _subkey) => (
                          <React.Fragment key={`input_${_subkey}`}>
                            {_subitem.input}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}
                </ExpandableContainer>

                {/* 검색/초기화 버튼 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: 48,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() => handleSearch('search')}
                  >
                    검색
                  </Button>
                  <Button
                    size="large"
                    style={{ ...styles.button }}
                    onClick={() => handleSearch('reset')}
                  >
                    초기화
                  </Button>
                </div>
              </Content>

              {/* 검색결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <Flex justify="space-between" align="center">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 20,
                    }}
                  >
                    <h4
                      style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                    >
                      총 <span>{filterList?.length}</span>개
                    </h4>
                    <Button
                      size="large"
                      style={{ marginRight: 8 }}
                      onClick={() =>
                        onOpen(isOpened, 'notice', {
                          is_show: 'Y',
                          show_target: 'ALL',
                        })
                      }
                    >
                      새 게시글
                    </Button>
                    <Button
                      style={{ marginRight: 8 }}
                      size="large"
                      onClick={() =>
                        downloadXlsx({
                          columns: col,
                          rows: filterList?.map((_item) => ({
                            ..._item,
                            show_target_html: _item?.show_target,
                          })),
                          fileName: '공지사항',
                        })
                      }
                    >
                      엑셀로 다운로드
                    </Button>
                    <Button
                      size="large"
                      style={{ marginRight: 8 }}
                      icon={<DeleteOutlined />}
                      danger
                      onClick={() => onDelete()}
                    >
                      선택 삭제
                    </Button>
                  </div>
                  <Select
                    options={SORT_ITEMS}
                    value={sortValue}
                    onChange={(e) => setSortValue(e)}
                    style={{ width: 200 }}
                  />
                </Flex>
                <Table
                  data={filterList}
                  isChecked
                  onRow={(item) => {
                    onOpen(isOpened, 'notice', { ...item });
                  }}
                  columns={col}
                  checkedAll={isCheckedAll}
                  checkedList={checkedList}
                  onChecked={onChecked}
                  onCheckedAll={onCheckedAll}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </Spin>

      {/* 모달 */}
      <ModalLayout
        type="modal"
        centered
        title={'공지사항 등록'}
        open={isOpened && modalType === 'notice'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={798}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'notice',
                  modalData?.notice?.notice_id ? 'UPDATE' : 'CREATE',
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              {modalType === 'DETAIL' ? (
                <div>
                  <HtmlContent content={modalData.notice_content} />
                </div>
              ) : (
                <InputFormTable form={form} labelWidth={148} />
              )}
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default NoticeListPresenter;
